'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconSvg = require('../IconSvg');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var IconEyeClosed = function IconEyeClosed(props) {
  return _react2.default.createElement(_IconSvg.IconSvg, props, _react2.default.createElement('svg', {
    viewBox: '0 0 24 24'
  }, _react2.default.createElement('g', null, _react2.default.createElement('path', {
    d: 'M19.7,7.4L17.1,10c0.2,0.6,0.4,1.3,0.4,2c0,3-2.5,5.5-5.5,5.5c-0.7,0-1.4-0.1-2-0.4l-1.8,1.8c1.2,0.4,2.4,0.6,3.8,0.6 c5,0,9.3-3.1,11-7.5C22.3,10.2,21.2,8.6,19.7,7.4z'
  }), _react2.default.createElement('path', {
    d: 'M15.5,12c0-0.1,0-0.2,0-0.3l-3.8,3.8c0.1,0,0.2,0,0.3,0C13.9,15.5,15.5,13.9,15.5,12z'
  }), _react2.default.createElement('path', {
    d: 'M19.3,2.3l-3,3C15,4.8,13.6,4.5,12,4.5C7,4.5,2.7,7.6,1,12c0.8,1.9,2,3.6,3.7,4.9l-2.4,2.4l1.4,1.4l17-17L19.3,2.3z M6.5,12C6.5,9,9,6.5,12,6.5c0.9,0,1.7,0.2,2.5,0.6L13,8.6c-0.3-0.1-0.6-0.1-0.9-0.1c-1.9,0-3.5,1.6-3.5,3.5c0,0.3,0,0.7,0.1,1 l-1.5,1.5C6.7,13.7,6.5,12.9,6.5,12z'
  }))));
};

exports.default = IconEyeClosed;